import { PushNotifications } from "@capacitor/push-notifications";
import { useEffect } from "react";
import RemoteDataController from "@controllers/RemoteDataController";
import DataController from "@controllers/DataController";
import { useLoggedIn } from "@hooks/auth/useLoggedIn";

export const useNotificationSetup = () => {
  const loggedIn = useLoggedIn();

  useEffect(() => {
    const notificationListenerSetup = async (): Promise<void> => {
      await PushNotifications.addListener("registration", (token) => {
        console.log("FCM token: ", token.value);
      });

      await PushNotifications.addListener("registrationError", (error) => {
        console.log("Registration error: ", error.error);
        RemoteDataController.logError(error.error);
      });

      await PushNotifications.addListener("pushNotificationReceived", (notification) => {
        console.log("Push notification received: ", notification);
      });

      await PushNotifications.addListener("pushNotificationActionPerformed", (notification) => {
        console.log("Push notification action performed: ", notification);

        if (notification?.notification && notification.notification.data) {
          if (notification.notification.data.deepLinkUrl) {
            location.href = notification.notification.data.deepLinkUrl;
          }
        }
      });
    };

    const pushNotificationSetup = async (): Promise<void> => {
      if (!(await DataController.isWebAsync())) {
        try {
          let permStatus = await PushNotifications.checkPermissions();

          if (permStatus.receive === "prompt") {
            permStatus = await PushNotifications.requestPermissions();
          }

          if (permStatus.receive !== "granted") {
            return;
          }

          await notificationListenerSetup();
          await PushNotifications.register();
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
          console.log(error);
          RemoteDataController.logError(error);
        }
      }
    };

    if (loggedIn) {
      pushNotificationSetup();
    }
  }, [loggedIn]);
};
